import request from '@/router/axios';
//查询组织列表(不带分页)
export const searchGroup = (data) => {
  return request({
    url: '/svolt-ess-boss-service/group/searchGroup',
    method: 'post',
    data: data
  })
}
//查询组织列表(带分页)
export const searchGroupPage = (data) => {
  return request({
    url: '/svolt-ess-boss-service/group/searchGroupPage',
    method: 'post',
    params: data
  })
}
//查询所有项目列表及其当前组织下项目选中
export const searchProjectList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/group/searchProjectList',
    method: 'post',
    data: data
  })
}

//添加组织
export const addGroup = (data) => {
  return request({
    url: '/svolt-ess-boss-service/group/addGroup',
    method: 'post',
    data: data
  })
}
//修改组织
export const updateGroup = (data) => {
  return request({
    url: '/svolt-ess-boss-service/group/updateGroup',
    method: 'post',
    data: data
  })
}
//导入组织下项目
export const saveCheckedProjectList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/group/saveCheckedProjectList',
    method: 'post',
    data: data
  })
}
//导入组织下项目-新接口
export const saveCheckedProjectListV2 = (data) => {
  return request({
    url: '/svolt-ess-boss-service/group/saveCheckedProjectListV2',
    method: 'post',
    data: data
  })
}
//查询组织下一级指标
export const searchConfigGroupStatistics = (data) => {
  return request({
    url: '/svolt-ess-boss-service/group/searchConfigGroupStatistics',
    method: 'post',
    data: data
  })
}
//查询码表类型
/*
codesType
码表类型
0微信图片名称
1电池类型
2厂商类型
3设备场景类型
4产品类型
5数据点数据类型
6设备供应商类型
7业主类型
8计算配置表计算类型
9计算配置表-redis数据类型
10项目展示项计算方式
11页签类型
12运维工单状态
13工单类型
14审核类型
15是否显示
16统一设备类型
17电价金额类型(尖峰谷平)
18模板显示界面
19设备名称展示类型
20设备数据点名称展示类型
21设备定位类型
22设备数据点定位类型
23设备数据点样式
24电价类型
 */
export const searchCodes = (data) => {
  return request({
    url: '/svolt-ess-boss-service/common/searchCodes',
    method: 'post',
    data: data
  })
}
//查询数据点码表类型
/* {
  "codesId": 0,
  "fieldsCodesType": 0
} */
export const searchFieldsCodes = (data) => {
  return request({
    url: '/svolt-ess-boss-service/common/searchFieldsCodes',
    method: 'post',
    data: data
  })
}
//查询组织算法实体列表-下拉
/*
 "entityId": "",
 "resourceId": 0
*/
export const searchAlgorithmEntitys = (data) => {
  return request({
    url: '/svolt-ess-boss-service/group/searchAlgorithmEntitys',
    method: 'post',
    data: data
  })
}

//查询组织指标已配置算法参数
/* {
  "entityId": "",
  "resourceId": 0
} */
export const searchConfigGroupStatisticsAlgorithmParam = (data) => {
  return request({
    url: '/svolt-ess-boss-service/group/searchConfigGroupStatisticsAlgorithmParam',
    method: 'post',
    data: data
  })
}
//查询组织指标已配置算法触发
/* {
  "entityId": ""
} */
export const searchConfigGroupStatisticsAlgorithmTrigger = (data) => {
  return request({
    url: '/svolt-ess-boss-service/group/searchConfigGroupStatisticsAlgorithmTrigger',
    method: 'post',
    data: data
  })
}
//查询组织配置计算实体
/* {
  "entityId": "",
  "resourceId": 0
} */
export const searchComputeConfiguration = (data) => {
  return request({
    url: '/svolt-ess-boss-service/group/searchComputeConfiguration',
    method: 'post',
    data: data
  })
}
//保存指标配置算法实体
export const saveConfigStatisticsAlgorithmEntity = (data) => {
  return request({
    url: '/svolt-ess-boss-service/common/saveConfigStatisticsAlgorithmEntity',
    method: 'post',
    data: data
  })
}

//保存指标配置算法参数
export const saveConfigStatisticsAlgorithmParam = (data) => {
  return request({
    url: '/svolt-ess-boss-service/common/saveConfigStatisticsAlgorithmParam',
    method: 'post',
    data: data
  })
}
//保存指标配置算法触发
export const saveConfigStatisticsAlgorithmTrigger = (data) => {
  return request({
    url: '/svolt-ess-boss-service/common/saveConfigStatisticsAlgorithmTrigger',
    method: 'post',
    data: data
  })
}
//保存配置计算实体
export const saveComputeConfigurationEntity = (data) => {
  return request({
    url: '/svolt-ess-boss-service/common/saveComputeConfigurationEntity',
    method: 'post',
    data: data
  })
}
//调整指标显示顺序
export const searchConfigGroupStatisticsListForOrder = (data) => {
  return request({
    url: '/svolt-ess-boss-service/group/searchConfigGroupStatisticsListForOrder',
    method: 'post',
    data: data
  })
}
//组织项目树列表
export const searchGroupProjectTreeList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/group/tree/searchGroupProjectTreeList',
    method: 'get',
    params: data
  })
}
//添加组织项目树
export const addGroupProjectTree = (data) => {
  return request({
    url: '/svolt-ess-boss-service/group/tree/addGroupProjectTree',
    method: 'post',
    data: data
  })
}
//查询组织下项目列表
export const searchProjectByGroup = (data) => {
  return request({
    url: '/svolt-ess-boss-service/group/tree/searchProjectByGroup',
    method: 'get',
    params: data
  })
}
//导入组织下项目
export const importGroupProjectTree = (data) => {
  return request({
    url: '/svolt-ess-boss-service/group/tree/importGroupProjectTree',
    method: 'post',
    data: data
  })
}
//删除组织项目树
export const deleteGroupProjectTree = (data) => {
  return request({
    url: '/svolt-ess-boss-service/group/tree/deleteGroupProjectTree',
    method: 'get',
    params: data
  })
}

/**
 * 储能2.0 
 */
//查询组织列表
export const searchGroupInfoByPageV2 = (data) => {
  return request({
    url: '/svolt-ess-boss-service/group/searchGroupInfoByPageV2',
    method: 'get',
    params: data
  })
}
//新增组织
export const addGroupInfoV2 = (data) => {
  return request({
    url: '/svolt-ess-boss-service/group/addGroupInfoV2',
    method: 'post',
    data: data
  })
}
//更新组织
export const updateGroupInfoV2 = (data) => {
  return request({
    url: '/svolt-ess-boss-service/group/updateGroupInfoV2',
    method: 'post',
    data: data
  })
}

export default {
  searchGroup,
  searchGroupPage,
  addGroup,
  updateGroup,
  searchProjectList,
  saveCheckedProjectList,
  saveCheckedProjectListV2,
  searchConfigGroupStatistics,
  searchCodes,
  searchFieldsCodes,
  searchAlgorithmEntitys,
  searchConfigGroupStatisticsAlgorithmParam,
  searchConfigGroupStatisticsAlgorithmTrigger,
  searchComputeConfiguration,
  saveConfigStatisticsAlgorithmEntity,
  saveConfigStatisticsAlgorithmParam,
  saveConfigStatisticsAlgorithmTrigger,
  saveComputeConfigurationEntity,
  searchConfigGroupStatisticsListForOrder,
  searchGroupProjectTreeList,
  addGroupProjectTree,
  searchProjectByGroup,
  importGroupProjectTree,
  deleteGroupProjectTree,
  searchGroupInfoByPageV2,
  addGroupInfoV2,
  updateGroupInfoV2
}



// WEBPACK FOOTER //
// ./src/api/group.js